import React from 'react'
import { DropDownList } from '@progress/kendo-react-dropdowns'
import { withTranslation } from 'react-i18next'

const locales = ['en', 'es']

function Footer(props) {
  const { onLocaleChange, t, locale } = props
  return (
    <div className="footer-wrapper cm-footer-position">
      <div className="footer-section f-section-1">
        <p className="">
          {t('Copyright')} {new Date().getUTCFullYear()}{' '}
          <a target="_blank" rel="noopener noreferrer" href="#">
            Ripple Secure
          </a>
          , {t('All rights reserved')}
        </p>
      </div>
      <div className="footer-section f-section-2">
        <p>V1.0.0</p>
      </div>
      <div>
        <DropDownList data={locales} value={locale} onChange={onLocaleChange} />
      </div>
    </div>
  )
}

export default withTranslation()(Footer)
